import { MHMButton, MHMButtonProps } from '../MHM/MHMButton';

type Props = Pick<MHMButtonProps, 'onClick' | 'children' | 'sx'> & {
  isActive: boolean;
};

export function NavButton({ isActive, onClick, sx, children }: Props) {
  return (
    <MHMButton
      variant={isActive ? 'contained' : 'outlined'}
      color="appBarText"
      sx={{
        fontWeight: 400,
        fontSize: 16,
        m: 0,
        px: 1.5,
        py: 0.75,
        ...sx,
        border: isActive ? '' : '1px solid',
        borderColor: isActive ? '' : 'appBarText.main',
      }}
      onClick={onClick}
    >
      {children}
    </MHMButton>
  );
}
